// extracted by mini-css-extract-plugin
export var discard = "_65-3";
export var muiTooltipTooltip = "_65-5";
export var notificationBar = "_65-2";
export var saveButtonHoverSlotWrapper = "_65-4";
export var show = "_65-1";
export var spacer = "_65-0";